import { Product } from '../types/types';

export const mockProducts: Product[] = [
    {
        id: 1,
        name: 'Premium Chicken & Rice Dog Food',
        description: 'Wholesome dry dog food made with real chicken as the first ingredient, brown rice, and garden vegetables. Formulated for adult dogs of all sizes with optimal protein levels for lean muscle maintenance.',
        category: 'Food',
        price: 54.99,
        imageUrl: '/images/products/dog-food.png',
        petType: 'Dog',
        inStock: true,
        featured: true,
        rating: 4.8,
        tags: ['grain-inclusive', 'high-protein', 'all-breeds'],
        createdAt: '2024-01-15T00:00:00Z',
        updatedAt: '2024-01-15T00:00:00Z',
        reviews: [
            { id: 1, productId: 1, reviewer: 'Sarah M.', rating: 5, comment: 'My golden retriever absolutely loves this food. His coat has never looked better!', createdAt: '2024-02-01T00:00:00Z' },
            { id: 2, productId: 1, reviewer: 'James K.', rating: 5, comment: 'Great quality ingredients and my dog eats every bite. Highly recommend.', createdAt: '2024-02-15T00:00:00Z' },
        ],
    },
    {
        id: 2,
        name: 'Wild-Caught Salmon Cat Food',
        description: 'Premium wet cat food featuring wild-caught salmon in a savory gravy. Rich in omega-3 fatty acids for a healthy coat and brain function. Grain-free formula for sensitive cats.',
        category: 'Food',
        price: 32.99,
        imageUrl: '/images/products/cat-food.png',
        petType: 'Cat',
        inStock: true,
        featured: true,
        rating: 4.7,
        tags: ['grain-free', 'omega-3', 'wet-food'],
        createdAt: '2024-01-20T00:00:00Z',
        updatedAt: '2024-01-20T00:00:00Z',
        reviews: [
            { id: 3, productId: 2, reviewer: 'Emily R.', rating: 5, comment: 'Finally a wet food my picky cat will eat! She goes crazy for this.', createdAt: '2024-02-10T00:00:00Z' },
        ],
    },
    {
        id: 3,
        name: 'Organic Peanut Butter Dog Treats',
        description: 'Crunchy biscuit treats made with organic peanut butter and oats. No artificial flavors, colors, or preservatives. Perfect for training rewards or everyday snacking.',
        category: 'Treats',
        price: 12.99,
        imageUrl: '/images/products/dog-treats.png',
        petType: 'Dog',
        inStock: true,
        featured: false,
        rating: 4.9,
        tags: ['organic', 'training', 'crunchy'],
        createdAt: '2024-01-25T00:00:00Z',
        updatedAt: '2024-01-25T00:00:00Z',
        reviews: [
            { id: 4, productId: 3, reviewer: 'Mike D.', rating: 5, comment: 'Best training treats ever! My puppy is so motivated by these.', createdAt: '2024-03-01T00:00:00Z' },
            { id: 5, productId: 3, reviewer: 'Lisa T.', rating: 5, comment: 'Love that these are organic. I feel good giving them to my dog.', createdAt: '2024-03-05T00:00:00Z' },
        ],
    },
    {
        id: 4,
        name: 'Freeze-Dried Catnip Treats',
        description: 'Irresistible freeze-dried chicken treats infused with premium catnip. Single ingredient protein with the bonus of catnip excitement. Cats go absolutely wild for these.',
        category: 'Treats',
        price: 8.99,
        imageUrl: '/images/products/cat-treats.png',
        petType: 'Cat',
        inStock: true,
        featured: false,
        rating: 4.6,
        tags: ['freeze-dried', 'catnip', 'single-ingredient'],
        createdAt: '2024-02-01T00:00:00Z',
        updatedAt: '2024-02-01T00:00:00Z',
        reviews: [
            { id: 6, productId: 4, reviewer: 'Anna P.', rating: 4, comment: 'My cats love these! They come running when they hear the bag crinkle.', createdAt: '2024-03-10T00:00:00Z' },
        ],
    },
    {
        id: 5,
        name: 'Joint Health Supplement for Dogs',
        description: 'Veterinarian-recommended joint support chews with glucosamine, chondroitin, and MSM. Helps maintain healthy joints and mobility in dogs of all ages. Tasty chicken flavor dogs love.',
        category: 'Health',
        price: 29.99,
        imageUrl: '/images/products/dog-supplement.png',
        petType: 'Dog',
        inStock: true,
        featured: true,
        rating: 4.5,
        tags: ['joint-health', 'glucosamine', 'vet-recommended'],
        createdAt: '2024-02-05T00:00:00Z',
        updatedAt: '2024-02-05T00:00:00Z',
        reviews: [
            { id: 7, productId: 5, reviewer: 'David W.', rating: 5, comment: 'My senior lab is moving so much better after just two weeks on these!', createdAt: '2024-03-15T00:00:00Z' },
        ],
    },
    {
        id: 6,
        name: 'Calming Anxiety Relief Drops',
        description: 'Natural calming drops for dogs and cats made with chamomile, valerian root, and L-theanine. Perfect for thunderstorms, fireworks, travel, or separation anxiety. Alcohol-free formula.',
        category: 'Health',
        price: 24.99,
        imageUrl: '',
        petType: 'All',
        inStock: true,
        featured: false,
        rating: 4.3,
        tags: ['calming', 'natural', 'anxiety-relief'],
        createdAt: '2024-02-10T00:00:00Z',
        updatedAt: '2024-02-10T00:00:00Z',
        reviews: [],
    },
    {
        id: 7,
        name: 'Leather Adjustable Dog Collar',
        description: 'Handcrafted genuine leather collar with brushed brass hardware. Adjustable fit with five size holes. Ages beautifully with a rich patina over time. Available in classic tan.',
        category: 'Accessories',
        price: 38.99,
        imageUrl: '',
        petType: 'Dog',
        inStock: true,
        featured: false,
        rating: 4.7,
        tags: ['leather', 'handcrafted', 'premium'],
        createdAt: '2024-02-15T00:00:00Z',
        updatedAt: '2024-02-15T00:00:00Z',
        reviews: [
            { id: 8, productId: 7, reviewer: 'Rachel B.', rating: 5, comment: 'Gorgeous collar! The leather quality is amazing and it looks so smart on my border collie.', createdAt: '2024-03-20T00:00:00Z' },
        ],
    },
    {
        id: 8,
        name: 'Interactive Feather Wand Cat Toy',
        description: 'Multi-segment telescoping wand with interchangeable feather, ribbon, and bell attachments. Encourages exercise and satisfies natural hunting instincts. Hours of interactive play.',
        category: 'Accessories',
        price: 14.99,
        imageUrl: '',
        petType: 'Cat',
        inStock: true,
        featured: false,
        rating: 4.4,
        tags: ['interactive', 'exercise', 'hunting'],
        createdAt: '2024-02-20T00:00:00Z',
        updatedAt: '2024-02-20T00:00:00Z',
        reviews: [
            { id: 9, productId: 8, reviewer: 'Tom H.', rating: 4, comment: 'My cat plays with this for ages. Great way to tire her out before bedtime!', createdAt: '2024-03-25T00:00:00Z' },
        ],
    },
    {
        id: 9,
        name: 'Seed & Fruit Bird Mix',
        description: 'Premium blend of sunflower seeds, safflower, millet, and dried tropical fruits. Nutritionally balanced for parakeets, cockatiels, and small parrots. No artificial colors or fillers.',
        category: 'Food',
        price: 18.99,
        imageUrl: '',
        petType: 'Bird',
        inStock: true,
        featured: true,
        rating: 4.6,
        tags: ['seed-mix', 'parakeets', 'no-fillers'],
        createdAt: '2024-02-25T00:00:00Z',
        updatedAt: '2024-02-25T00:00:00Z',
        reviews: [
            { id: 10, productId: 9, reviewer: 'Grace L.', rating: 5, comment: 'My cockatiel loves this mix! Great variety of seeds and fruit pieces.', createdAt: '2024-04-01T00:00:00Z' },
        ],
    },
    {
        id: 10,
        name: 'Cozy Sherpa Pet Bed',
        description: 'Ultra-soft sherpa-lined pet bed with memory foam base. Machine washable removable cover. Non-slip bottom keeps bed in place. Perfect for dogs and cats who love to curl up.',
        category: 'Lifestyle',
        price: 64.99,
        imageUrl: '',
        petType: 'All',
        inStock: true,
        featured: false,
        rating: 4.8,
        tags: ['memory-foam', 'washable', 'non-slip'],
        createdAt: '2024-03-01T00:00:00Z',
        updatedAt: '2024-03-01T00:00:00Z',
        reviews: [
            { id: 11, productId: 10, reviewer: 'Karen S.', rating: 5, comment: 'My dog claimed this bed the moment I put it down. So plush and comfy!', createdAt: '2024-04-05T00:00:00Z' },
            { id: 12, productId: 10, reviewer: 'Chris M.', rating: 5, comment: 'Both our cat and dog fight over this bed. Need to order a second!', createdAt: '2024-04-10T00:00:00Z' },
        ],
    },
    {
        id: 11,
        name: 'Halloween Pet Costume Set',
        description: 'Adorable pumpkin costume set with matching bandana and collar charm. Soft, breathable fabric that pets actually tolerate wearing. Adjustable straps for a comfortable fit.',
        category: 'Seasonal',
        price: 22.99,
        imageUrl: '',
        petType: 'Dog',
        inStock: true,
        featured: false,
        rating: 4.2,
        tags: ['halloween', 'costume', 'seasonal'],
        createdAt: '2024-03-05T00:00:00Z',
        updatedAt: '2024-03-05T00:00:00Z',
        reviews: [],
    },
    {
        id: 12,
        name: 'Holiday Gift Box for Cats',
        description: 'Curated holiday gift set with catnip mice, a jingle ball trio, feather teaser, and gourmet salmon treats. Packaged in a festive gift box — perfect for the cat lover in your life.',
        category: 'Seasonal',
        price: 34.99,
        imageUrl: '',
        petType: 'Cat',
        inStock: true,
        featured: false,
        rating: 4.5,
        tags: ['holiday', 'gift-set', 'curated'],
        createdAt: '2024-03-10T00:00:00Z',
        updatedAt: '2024-03-10T00:00:00Z',
        reviews: [
            { id: 13, productId: 12, reviewer: 'Jen W.', rating: 5, comment: 'Got this for my sister\'s cats — they were obsessed! Great gift idea.', createdAt: '2024-04-15T00:00:00Z' },
        ],
    },
    {
        id: 13,
        name: 'Hamster Deluxe Habitat Kit',
        description: 'Complete modular habitat with tunnels, exercise wheel, water bottle, and food dish. Expandable tube system for endless configurations. Easy-clean removable tray.',
        category: 'Lifestyle',
        price: 49.99,
        imageUrl: '',
        petType: 'Small Animal',
        inStock: true,
        featured: false,
        rating: 4.4,
        tags: ['habitat', 'modular', 'complete-kit'],
        createdAt: '2024-03-15T00:00:00Z',
        updatedAt: '2024-03-15T00:00:00Z',
        reviews: [
            { id: 14, productId: 13, reviewer: 'Alex R.', rating: 4, comment: 'My daughter loves rearranging the tunnels. Great starter kit for a hamster.', createdAt: '2024-04-20T00:00:00Z' },
        ],
    },
    {
        id: 14,
        name: 'Omega-3 Fish Oil for Pets',
        description: 'Pure wild-caught fish oil supplement for dogs and cats. Supports healthy skin, shiny coat, joint function, and heart health. Easy-to-use pump dispenser. No fishy smell.',
        category: 'Health',
        price: 19.99,
        imageUrl: '',
        petType: 'All',
        inStock: true,
        featured: true,
        rating: 4.7,
        tags: ['omega-3', 'fish-oil', 'coat-health'],
        createdAt: '2024-03-20T00:00:00Z',
        updatedAt: '2024-03-20T00:00:00Z',
        reviews: [
            { id: 15, productId: 14, reviewer: 'Pat N.', rating: 5, comment: 'Huge improvement in my dog\'s dry, itchy skin after just one bottle. A staple now!', createdAt: '2024-04-25T00:00:00Z' },
        ],
    },
    {
        id: 15,
        name: 'Retractable Dog Leash',
        description: 'Smooth-retracting 16-foot leash with ergonomic grip and one-button brake. Reflective cord for visibility. Durable for dogs up to 65 lbs. Freedom to explore with safety.',
        category: 'Accessories',
        price: 26.99,
        imageUrl: '',
        petType: 'Dog',
        inStock: true,
        featured: false,
        rating: 4.3,
        tags: ['retractable', 'reflective', 'ergonomic'],
        createdAt: '2024-03-25T00:00:00Z',
        updatedAt: '2024-03-25T00:00:00Z',
        reviews: [],
    },
    {
        id: 16,
        name: 'Automatic Pet Water Fountain',
        description: 'Whisper-quiet 2L water fountain with triple filtration system. Encourages hydration with flowing water. BPA-free, dishwasher-safe parts. Suitable for cats and small dogs.',
        category: 'Lifestyle',
        price: 39.99,
        imageUrl: '',
        petType: 'All',
        inStock: true,
        featured: false,
        rating: 4.6,
        tags: ['water-fountain', 'filtered', 'quiet'],
        createdAt: '2024-04-01T00:00:00Z',
        updatedAt: '2024-04-01T00:00:00Z',
        reviews: [],
    },
    {
        id: 17,
        name: 'Spring Floral Dog Bandana Set',
        description: 'Set of three reversible bandanas in fresh spring botanical prints. Soft cotton fabric with snap closure for easy on/off. Machine washable. One size adjusts for most dogs.',
        category: 'Seasonal',
        price: 16.99,
        imageUrl: '',
        petType: 'Dog',
        inStock: true,
        featured: false,
        rating: 4.5,
        tags: ['spring', 'bandana', 'reversible'],
        createdAt: '2024-04-05T00:00:00Z',
        updatedAt: '2024-04-05T00:00:00Z',
        reviews: [],
    },
    {
        id: 18,
        name: 'Natural Dental Chews for Dogs',
        description: 'Veterinary-formulated dental chews that clean teeth, freshen breath, and reduce tartar buildup. Made with natural ingredients including peppermint and parsley. Daily dental care dogs enjoy.',
        category: 'Treats',
        price: 21.99,
        imageUrl: '',
        petType: 'Dog',
        inStock: true,
        featured: true,
        rating: 4.8,
        tags: ['dental', 'natural', 'vet-formulated'],
        createdAt: '2024-04-10T00:00:00Z',
        updatedAt: '2024-04-10T00:00:00Z',
        reviews: [],
    },
];
